import React, { useRef, useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const WIDTH = 400;
const HEIGHT = 400;
const VisualLink = ({setCoords, sample, coords= {x:0, y:0}}) => { 
    let [target, setTarget] = useState({x:0, y:0});
    let parent = useRef(undefined);

    useEffect(() => {
        let element = document.getElementById('sample-option-' + sample.getId());
        if (!element) { return; }
        let rect = element.getBoundingClientRect();
        setCoords({x : rect.left - WIDTH - 100, y: Math.min(window.innerHeight - 100 - HEIGHT, rect.top - HEIGHT/2)});
    }, []);


    useEffect(() => {
        let element = document.getElementById('sample-option-' + sample.getId());
        if (!element) { return undefined; }
        let scroll = getParentScroll(element);
        parent.current = scroll;
        scroll.addEventListener("scroll", calculatePts);
        calculatePts();
        return () => 
            scroll.removeEventListener("scroll", calculatePts);
    }, [sample, setTarget]);

    const calculatePts = useCallback((e) => {
        let element = document.getElementById('sample-option-' + sample.getId());
        if (!element) { return undefined; }
        let rect = element.getBoundingClientRect();
        let pRect = parent.current.getBoundingClientRect();
        setTarget({
            x : rect.left, y:
            Math.min(parent.current.offsetHeight + pRect.top ,Math.max(pRect.top, rect.top))});
    }, [sample, setTarget]);

    return (
        <svg className="visual-link">
          <linearGradient id="MyGradient">
            <stop offset="5%" stopColor="#1f0a72d6" />
            <stop offset="95%" stopColor="#9580e8d6" />
          </linearGradient>
          <polygon points={[
              coords.x + WIDTH, coords.y,
              coords.x + WIDTH, coords.y + HEIGHT,
              target.x, target.y + 20,
              target.x, target.y
          ]}/>
        </svg>);
}

const getParentScroll = (e) => {
    let parent = e.parentElement;
    let i=0;
    while (parent && ++i < 10) {
        if (parent.className.includes("inner-explorer")) {
            return parent;
        }
        parent = parent.parentElement;
    }
    return parent;
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VisualLink);
